import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { toast } from 'react-toastify';

import { OrganizationProvider } from './context/OrganizationContext';
import { UserProvider } from './context/UserContext';
import { Routes } from './routes/routes';

import 'react-toastify/dist/ReactToastify.css';

toast.configure();

function App() {
	return (
		<OrganizationProvider>
			<UserProvider>
				<Router>
					<Routes />
				</Router>
			</UserProvider>
		</OrganizationProvider>
	);
}

export default App;
